<template>
    <b-container>
    <div style="height: 450px; width: 100%">
        <l-map
            v-if="visible"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            style="height: 99%"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            ref="mapHistoryCoordinates"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
          <l-polyline
              :lat-lngs="polyline.latlngs"
              :color="polyline.color"
              :weight="polyline.weight"
              ref="polyline"
          ></l-polyline>


          <l-marker v-for="point in points" :key="point.identity" :lat-lng=point.latlng :icon="icon">
                <l-popup>
                    <div>
                      date: {{point.date}} <br>
                      course: {{point.course}}<br>
                      height: {{point.height}}<br>
                      satellites: {{point.satellites}}<br>
                      speed: {{point.speed}}
                    </div>
                </l-popup>
            </l-marker>
<!--            <l-marker :lat-lng="withTooltip">-->
<!--                <l-tooltip :options="{ permanent: true, interactive: true }">-->
<!--                    <div @click="innerClick">-->
<!--&lt;!&ndash;                        I am a tooltip&ndash;&gt;-->
<!--&lt;!&ndash;                        <p v-show="showParagraph">&ndash;&gt;-->
<!--&lt;!&ndash;                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque&ndash;&gt;-->
<!--&lt;!&ndash;                            sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.&ndash;&gt;-->
<!--&lt;!&ndash;                            Donec finibus semper metus id malesuada.&ndash;&gt;-->
<!--&lt;!&ndash;                        </p>&ndash;&gt;-->
<!--                    </div>-->
<!--                </l-tooltip>-->
<!--            </l-marker>-->
        </l-map>
    </div>
      <div>
      <b-form @submit.prevent="onSubmit">
      <b-row>
        <b-col>
          <b-input-group class="mb-3">
              <b-form-datepicker
                  v-model="form.from"
                  button-only
                  right
                  locale="en-US"
                  aria-controls="from"
                  @context="onContext"
              />
              <b-form-input
                  v-model="form.from"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
              />
            <b-input-group-append>
              <b-form-input
                  v-model="form.from_time"
                  type="text"
                  placeholder="HH:mm:ss"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group class="mb-3">
            <b-form-datepicker
                v-model="form.to"
                button-only
                right
                locale="en-US"
                aria-controls="to"
                @context="onContext"
            />
            <b-form-input
                v-model="form.to"
                type="text"
                placeholder="YYYY-MM-DD"
                autocomplete="off"
            />
            <b-input-group-append>
              <b-form-input
                  v-model="form.to_time"
                  type="text"
                  placeholder="HH:mm:ss"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="mb-3">
        <b-button type="submit" variant="primary">{{$t('apply')}}</b-button>
        </div>
      </b-row>
      </b-form>
        <div v-if="notDataVisible">
          {{$t('data.empty')}}
        </div>
    </div>
    </b-container>
</template>

<script>
import { latLng } from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline,
    // LIcon
    // LTooltip
} from "vue2-leaflet";
import { Icon } from 'leaflet';
import axios from "axios";


delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
import L from 'leaflet';

export default {
    name: "MonitoringHistoryCoordinates",
    props: {
        id: {
            type: Number
        },
        visible: {
            type: Boolean
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline,
        // LIcon
        // LTooltip
    },
    data() {
        return {
            isBusy: false,
            zoom: 13,
            center: latLng(55.7537, 37.619813),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: "",
            withPopup: latLng(55.7537, 37.619813),
            // withTooltip: latLng(55.7537, 37.619813),
            currentZoom: 11.5,
            currentCenter: latLng(55.7537, 37.619813),
            showParagraph: false,
            icon: L.icon({
              iconUrl: 'assets/images/red-dot.png',
              iconSize: [8, 8],
              iconAnchor: [4, 4]
            }),
            mapOptions: {
                // zoomSnap: 0.5
            },
            polyline: {
              latlngs: [],
              color: 'red',
              weight: 4
            },
            points: [],
            notDataVisible: false,
            showMap: false,
            updateAvailable: true,
            hover: true,
            items: [],
            fields: [],
            filterOn: [],
            perPage: 15,
            totalRows: 1,
            currentPage: 1,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            form: {
              from: '',
              from_time: '00:00:00',
              to: '',
              to_time: '23:59:59'
            },
            pagination: {
              currentPage: 1,
              rows: 0,
            },
            sorting: {
              sortBy: 'customId',
              sortDesc: true,
            },
            filters: {
                from_date: null,
                from_time: '00:00:00',
                to_date: null,
                to_time: '23:59:59'

            },
            filterListTable: {

            },
        };
    },
    methods: {
      onSubmit() {
        // event.preventDefault()
        // console.log(this.form)
        // alert(1111)
        // alert(JSON.stringify(this.form))
        this.loadData();
      },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            // alert(111)
            this.currentCenter = center;
            // console.log('map was moved')
        },
        onRowClicked(item) {
            this.withPopup = item.point;
            this.setCenter(item.point);
        },
        showLongText() {
            this.showParagraph = !this.showParagraph;
        },
        innerClick() {
            alert("Click!");
        },
        setCenter(center) {
            const mapComponent = this.$refs.mapHistoryCoordinates;
            mapComponent.setCenter(center)
            mapComponent.mapObject.flyTo(center)
        },
        onContext(ctx) {
          this.context = ctx
        },
        loadData() {
        // console.log(ctx)
        // Here we don't set isBusy prop, so busy state will be
        // handled by table itself

        let param = {
            }
        ;

          param.from = this.form.from + ' ' + this.form.from_time;
          param.to = this.form.to + ' ' + this.form.to_time;

        // this.isBusy = true
        let promise = axios.get(
            'api/v1/devices/' + this.id + '/packets/coordinates',
            { params: param }
        )

        return promise.then((data) => {
          // console.log(data.data)

          this.notDataVisible = false;

          const items = [];

          this.polyline.latlngs = [];
          this.points = [];

          data.data.records.forEach(
              item => {
                let point = null;

                if (item.coordinates.latitude !== null &&  item.coordinates.longitude != null) {
                  point = latLng(item.coordinates.latitude, item.coordinates.longitude);
                  this.polyline.latlngs.push(point);
                  this.points.push(
                      {
                        identity:item.identity,
                        latlng:point,
                        date: item.date,
                        course: item.coordinates.course,
                        height: item.coordinates.height,
                        satellites: item.coordinates.satellites,
                        speed: item.coordinates.speed
                      }
                      );
                }

                // this.polyline.latlngs.push(point);
              }
          )

// zoom the map to the polyline
//           this.$refs.map.fitBounds(this.this.polyline.latlngs.getBounds());

          this.totalRows = data.data.records.length;

          if (!this.totalRows > 0) {
              this.notDataVisible = true;
          }

          // Here we could override the busy state, setting isBusy to false
          // this.pagination.rows = data.data.records
          // console.log(data.data)
          // this.isBusy = false

          // localStorage.setItem('deviceListFilters', JSON.stringify(this.filters));
          // localStorage.setItem('deviceListPagination', JSON.stringify(this.pagination));
          // localStorage.setItem('deviceListSorting', JSON.stringify(this.sorting));

          // console.log(this.$refs.polyline.options);

          // this.$refs.mapHistoryCoordinates.fitBounds(polyline.getBounds());

          this.$refs.mapHistoryCoordinates.fitBounds([
            this.polyline.latlngs
          ])

          return(items)
        }).catch(() => {
            this.notDataVisible = true;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          // console.log(error)
          return []
        })
      },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        updateFields() {
        let index = 0;

        this.fields = [];
        this.availableColumns.forEach(
            column => {
              column.order = ++index;
              if (column.visible === true) {
                column.label = this.$t(column.label_t)

                this.fields.push(column);
              }
            }
        )
      },
        selectSelected() {
        // console.log('select');
        // console.log(this.$refs.table);
        // console.log(this.$refs.table.renderBusy());
        // console.log(this.$refs.table.busy);

        // let t = this.$refs.table;
        // let s = [];
        //
        // this.selected.forEach(
        //     (value, index) => {
        //       s[index] = value;
        //     }
        // )

      },
    },
    mounted() {

      Date.prototype.yyyymmdd = function() {
        const mm = this.getMonth() + 1; // getMonth() is zero-based
        const dd = this.getDate();

        return [this.getFullYear(),
          (mm>9 ? '' : '0') + mm,
          (dd>9 ? '' : '0') + dd
        ].join('-');
      };

      const now = new Date();
      this.form.from = now.yyyymmdd();
      this.form.to = now.yyyymmdd();
    },
    created() {
    }
};
</script>
